import { render, staticRenderFns } from "./messageMenu.vue?vue&type=template&id=b41d549e"
import script from "./messageMenu.vue?vue&type=script&lang=js"
export * from "./messageMenu.vue?vue&type=script&lang=js"
import style0 from "./messageMenu.vue?vue&type=style&index=0&id=b41d549e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports